<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="4"></ucMenu>
          <div class="right_con">
            <div class="wallet_main">
              <div class="ye_wrap">
                <p class="fb">我的余额</p>
                <p class="balance"><em>{{ wallet_money_d }}</em>.{{ wallet_money_x }}</p>
                <div class="btn_wrap">
                  <p class="btn" @click.self="openWalletRecharge">立即充值</p>
                  <!--									<p class="btn" @click.self="is_tixian = true">提现</p>-->
                </div>
              </div>
              <div class="ye_wrap">
                <p class="fb">AI算力</p>
                <p class="balance">
                  <em>{{ formatPrice(userinfo.power_num,0) }}</em>.{{formatPrice(userinfo.power_num,1) }}
                  </p>
                <div class="btn_wrap">
                  <p class="btn" @click.self="$refs.rechargePower.show()">立即充值</p>
                </div>
              </div>
              <div class="ye_wrap">
                <p class="fb">常规算力</p>
                <p class="balance"><em>{{ formatPrice(userinfo.conventional_computing_power,0) }}</em>.{{formatPrice(userinfo.conventional_computing_power,1) }}</p>
                <div class="btn_wrap"><p class="btn" @click.self="$refs.rechargeConventionalPower.show()">立即充值</p></div>
              </div>
              <div class="ye_wrap">
                <p class="fb">铺货算力</p>
                <p class="balance">
                  <em>{{ formatPrice(userinfo.distribution_computing_power,0) }}</em>.{{formatPrice(userinfo.distribution_computing_power,1) }}
                </p>
                <div class="btn_wrap">
                  <p class="btn" @click.self="$refs.rechargeQuota.show()">立即充值</p>
                </div>
              </div>
              <!--              <div class="ye_wrap">
                              <p class="fb">可用于采购余额
                                <el-tooltip class="item" effect="dark" placement="top-start">
                                  <div slot="content" class="tooltip-content" style="font-size:16px">
                                    <p>可用于采购余额 = 我的余额 - （冻结金额 *  30%）</p>
                                  </div>
                                  <i class="iconfont el-icon-question" ></i>
                                </el-tooltip>
                              </p>
                              <p class="balance"><em>{{caigou_able}}</em></p>
                            </div>-->
              <!--							<div class="dk_wrap">
                              &lt;!&ndash; <p>
                                <i class="iconfont icon-suo"></i>
                                抵扣金:<em>{{wallet_deduction}}</em>
                                <i class="iconfont icon-shuoming" @click="$router.push('./notice?type=2&id=1')"></i>
                              </p>
                              <p>
                                <i class="iconfont icon-suo"></i>
                                待解冻抵扣金:<em>{{wallet_etc_deduction}}</em>
                                <i class="iconfont icon-shuoming" @click="$router.push('./notice?type=2&id=2')"></i>
                              </p> &ndash;&gt;
                              <p style="margin-top: 18px;">
                                <i class="iconfont el-icon-unlock" ></i>可提现余额:<em>{{tixian_able}}  </em>
                                <el-tooltip class="item" effect="dark" placement="top-start">
                                  <div slot="content" class="tooltip-content" style="font-size:16px">
                                    <p>可提现余额 = 我的余额 - 冻结金额</p>
                                  </div>
                                  <i class="iconfont el-icon-question" ></i>
                                </el-tooltip>
                              </p>
                              <p style="margin-top: 10px;">
                                <i class="iconfont icon-suo" ></i>冻结金额:<em>{{freeze}}  </em>
                                <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content" class="tooltip-content" style="font-size:16px">
                                  <p>冻结金额：当退货送至供应商退货退款存在一定结算周期时间，</p>
                                  <p>星好货平台考虑到用户资金周转情况，平台退货送至供应商后，</p>
                                  <p>仓库确认后货款进入冻结金额，冻结金额的70%资金用于采购,</p>
                                  <p>30%不可用，冻结金额暂不可提现，供应商和星好货结算完成，</p>
                                  <p>会把冻结的资金解冻出来，可用于采购和提现。</p>
                                </div>
                                  <i class="iconfont el-icon-question" ></i>
                                </el-tooltip>
                              </p>
                            </div>-->
            </div>
            <div class="record_main">
              <el-tabs v-model="activeTab" @tab-click="handleReset">
                <el-tab-pane label="余额记录" name="1"></el-tab-pane>
                <el-tab-pane label="AI算力" name="2"></el-tab-pane>
                <el-tab-pane label="常规算力" name="5"></el-tab-pane>
                <el-tab-pane label="铺货算力" name="4"></el-tab-pane>
                <el-tab-pane label="统计数据" name="3"></el-tab-pane>
              </el-tabs>
              <template v-if="['1','2','5'].includes(activeTab)">
                <el-form :inline="true" :model="formInline" size="small">
                  <el-form-item label="变动类型">
                    <el-select v-model="searchParams.type" clearable placeholder="变动类型" style="width: 150px"  @change="handleSearch(1)">
                      <el-option v-for="(item,index) in typeConfig" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="收支" >
                    <el-select v-model="searchParams.use_type" clearable placeholder="收支" style="width: 150px" @change="handleSearch(1)">
                      <el-option v-for="(item,index) in useTypeConfig" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <template v-if="['2','5'].includes(activeTab)">
                     <el-form-item label="关联单号">
                       <el-input v-model="searchParams.order_no" placeholder="请输入关联单号" clearable></el-input>
                     </el-form-item>
                     <el-form-item>
                       <el-button type="primary" size="small" @click="handleSearch(1)">查询</el-button>
                       <el-button plain size="small" @click="handleReset()">重置</el-button>
                     </el-form-item>
                   </template>
                  <el-form-item v-else>
                    <el-button size="small" @click="handleSearch(1)">刷新</el-button>
                  </el-form-item>
    <!--                <el-form-item label="日期">-->
    <!--                  <el-date-picker-->
    <!--                      v-model="rangeTime"-->
    <!--                      type="datetimerange"-->
    <!--                      range-separator="-"-->
    <!--                      start-placeholder="开始日期"-->
    <!--                      end-placeholder="结束日期"-->
    <!--                      :clearable="false"-->
    <!--                      format="yyyy-MM-dd HH:mm">-->
    <!--                  </el-date-picker>-->
    <!--                </el-form-item>-->
    <!--                <el-form-item>-->
    <!--                  <el-button plain size="medium" @click="timeCheck()">查询</el-button>-->
    <!--                </el-form-item>-->
    <!--                <el-form-item>-->
    <!--                  <el-button type="warning" plain size="medium" @click="onExport()" :loading="exLoading">-->
    <!--                    {{ exLoading ? '导出中...' : '导出' }}-->
    <!--                  </el-button>-->
    <!--                </el-form-item>-->
                </el-form>
                <div class="table_wrap" >
                  <el-table :data="tableData" style="width: 100%" v-loading="loading" :key="random+1" >
                    <el-table-column label="关联单号" prop="order_no" align="center"> </el-table-column>
                    <el-table-column label="变动类型" prop="type_name" align="center"> </el-table-column>
                    <el-table-column label="收支" prop="use_type_name" align="center"> </el-table-column>
                    <el-table-column :label="activeTab==='1'?'变动金额':'变动算力值'" :prop="activeTab==='5' ? 'change_amount' : 'change'" align="center"> </el-table-column>
                    <el-table-column label="钱包余额" prop="money" align="center" v-if="activeTab==='1'" > </el-table-column>
                    <el-table-column label="算力值余额" :prop="activeTab==='5' ? 'balance_after' : 'power_num'" align="center" v-else> </el-table-column>
                    <el-table-column label="创建时间" prop="created_at" align="center" min-width="100"> </el-table-column>
                    <el-table-column label="备注" prop="remark" align="center"> </el-table-column>
                  </el-table>
                </div>
                <div class="turn_page" >
                  <el-pagination
                      @size-change="sizeChange"
                      @current-change="currentChange"
                      :current-page="page"
                      :page-sizes="[10, 20, 50, 100,  200, 300, 400]"
                      :page-size="page_size"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="listTotal">
                  </el-pagination>
                </div>
              </template>
              <statisics-list :key="activeTab + '_list'" ref="statisicslistRef" v-if="activeTab==='3'"></statisics-list>
              <comput-power-list :key="activeTab + '_list'" ref="computPowerListRef" v-if="activeTab==='4'"></comput-power-list>
            </div>
          </div>
        </div>
        <el-dialog class="chongzhi_mask" :visible.sync="is_chongzhi" width="500px" @closed="stopWalletRechargeStatusPolling">
          <div class="chongzhi_main">
            <p class="title"><img class="icon" src="../../assets/images/zhifubao.png"/>余额充值</p>
            <el-tabs v-model="rechargeMode" class="recharge-tabs" stretch>
              <el-tab-pane label="支付宝网站支付" name="web">
                <div class="input_line">
                  <p class="txt">充值金额：</p>
                  <el-input class="in" placeholder="请输入 1.00 - 50000.00" v-model.trim="walletRechargeAmount">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div v-if="walletRechargeOrder" class="wallet-recharge-status">
                  已在新标签页打开支付宝，支付完成后会自动到账。<br>
                  订单号：{{ walletRechargeOrder.out_trade_no }}
                </div>
                <div class="recharge-notice">开启自动采购的商家充值成功后会自动采购24小时内未采购订单</div>
                <div class="btn_wrap">
                  <p class="btn" @click.self="is_chongzhi = false">取消</p>
                  <p class="btn" :class="{ disabled: walletRechargeLoading }" @click="startWalletRecharge">{{ walletRechargeLoading ? '创建中...' : '支付宝支付' }}</p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="已有订单校验" name="verify">
                <div class="input_line">
                  <p class="txt">订单号：</p>
                  <el-input class="in" placeholder="输入支付订单编号" v-model.trim="paymentNum"></el-input>
                </div>
                <div class="recharge-notice">开启自动采购的商家充值成功后会自动采购24小时内未采购订单</div>
                <div class="btn_wrap">
                  <p class="btn" @click.self="is_chongzhi = false">取消</p>
                  <p class="btn" :class="{ disabled: is_payment }" @click="bindRecharge">{{ is_payment ? '校验中...' : '确认校验' }}</p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
        <el-dialog class="tixian_mask" :visible.sync="is_tixian" width="400px">
          <div class="tixian_main">
            <p class="title"><i class="iconfont icon-qian"></i>余额提现<span
                class="t">（可提现金额 <em>￥{{ tixian_able }}</em>）</span></p>
            <div class="tx_count">
              <input v-model="input_tixian" class="in" placeholder="输入提现金额"/>
              <p class="tx" @click="input_tixian = tixian_able">全部提现</p>
            </div>
            <el-input v-model="input_zfbName" placeholder="输入支付宝名称" class="el_input el_in2" @input="checkInput">
              <p slot="prefix" class="txts">支付宝名称</p>
            </el-input>
            <el-input v-model="input_zfbMember" placeholder="输入支付宝账号" class="el_input el_in2"
                      @input="checkInput">
              <p slot="prefix" class="txts">支付宝账号</p>
            </el-input>
            <el-input :value="phone" placeholder="输入手机号码" class="el_input el_in2" readonly v-if="has_zfb">
              <p slot="prefix" class="txts">手机号码</p>
            </el-input>
            <el-input v-model="phoneCode" placeholder="输入短信验证码" class="el_input el_in2" v-if="has_zfb">
              <p slot="prefix" class="txts">验证码</p>
              <!-- <p slot="suffix" class="getcode">获取验证码</p> -->
              <p slot="suffix" class="getcode" @click="getPhoneCode('4')">
                {{ is_get_phone_code ? phone_second + 's重新获取' : '获取验证码' }}</p>
            </el-input>
            <div class="btn_wrap">
              <p class="btn" @click.self="is_tixian = false">取消</p>
              <p class="btn" @click="bindTixian">确定</p>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <recharge-power ref="rechargePower" :userInfo="userInfo" @refresh="refreshCharge"></recharge-power>
    <recharge-power ref="rechargeConventionalPower" :userInfo="userInfo" :computingPowerType="2" @refresh="refreshCharge"></recharge-power>
    <recharge-quota ref="rechargeQuota" :userInfo="userInfo" @success="refreshComputPower"></recharge-quota>
    <myFoot></myFoot>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import RechargePower from "./rechargePower.vue";
import StatisicsList from "./statistics/index.vue";
import ComputPowerList from "@/pages/uc_wallet/computPowerList.vue";
import RechargeQuota from "@/components/recharge/Recharge.vue";

export default {
  name: "ucenterWallet",
  data() {
    return {
      activeTab: "1",
      formInline: {
        order_no: '',
      },
      random:Math.random(),
      rangeTime: "",
      startTime: "",
      endTime: "",
      is_chongzhi: false,
      is_tixian: false,
      tableData: [],
      wallet_money_d: "0",
      wallet_money_x: "00",
      wallet_deduction: "0.00",
      wallet_etc_deduction: "0.00",
      paymentNum: "",
      is_payment: false,
      rechargeMode: "web",
      walletRechargeAmount: "",
      walletRechargeLoading: false,
      walletRechargeOrder: null,
      walletRechargeStatusTimer: null,
      walletRechargeWindow: null,
      is_doTixian: false,
      tixian_able: "0.00",
      caigou_able: "0.00",
      input_tixian: "",
      zfbMember: "",
      zfbName: "",
      input_zfbMember: "",
      input_zfbName: "",
      phone: "",
      phoneCode: "",
      has_zfb: false,
      is_get_phone_code: false,
      phone_second: 60,
      recordType: "",
      page: 1,
      page_size: 10,
      listTotal: 0,
      freeze: 0,
      exLoading: false,
      typeConfig:[],
      useTypeConfig:[],
      searchParams:{},
      userInfo:{},
      loading:false,
      computPowerType: [
        {value: 'recharge',label: '充值'},
        {value: 'use',label: '消耗'},
        {value: 'return',label: '退还'},
        {value: 'gift',label: '赠送'},
        {value: 'recover',label: '扣除'}
      ]
    }
  },
  components: {
    myHead, myFoot, ucMenu, RechargePower, StatisicsList,ComputPowerList,RechargeQuota
  },
  computed: {
    ...mapState({
      userinfo: (state) => state.login.userinfo,
    }),
  },
  created() {
    this.phone = this.userinfo.mobile
    // this.wallet_money_d = parseInt(this.userinfo.money)
    // this.wallet_money_x = this.userinfo.money.slice(-2)
    this.refreshCharge()
  },
  methods: {
    ...mapActions({
      getMoneyData: "ucenter/getMoneyData",
      getCheckRecharge: "ucenter/getCheckRecharge",
      createWalletRechargeOrder: "ucenter/createWalletRechargeOrder",
      getWalletRechargeOrder: "ucenter/getWalletRechargeOrder",
      getTixianInfo: "ucenter/getTixianInfo",
      doTixian: "ucenter/doTixian",
      getCodeData: "login/getCodeData",
      getWallteData: "ucenter/getWallteData",
      opExportBasinessJineFlow: "ucenter/opExportBasinessJineFlow",
      getPowerFinanceList: "ucenter/getPowerFinanceList",
      getConventionalComputingPowerFinanceList: "ucenter/getConventionalComputingPowerFinanceList",
      getUserinfoData:'login/getUserinfoData'
    }),
    formatPrice(price,index){
      let arr = price?String(price).split('.'):['0','00']
      return arr[index]
    },
    refreshCharge(){
      this.getWalletInfo()
      this.handleReset()
    },
    getWalletInfo() {//获取钱包数据，可提现数据
      this.getUserinfoData({
        data: {}, success: (res) => {
          if (res.code === 200) {
            this.userInfo = res.data
            this.wallet_money_d = parseInt(res.data.money)
            this.wallet_money_x = res.data.money.slice(-2)
            // this.wallet_deduction = res.data.deduction
            // this.wallet_etc_deduction = res.data.stay_thaw
            // this.freeze = res.data.freeze
            // let tixian_money = (parseFloat(res.data.money) - parseFloat(this.freeze));
            // this.caigou_able = (parseFloat(res.data.money) - parseFloat(this.freeze) * 0.3).toFixed(2);
            // this.tixian_able = tixian_money > 0 ? tixian_money : 0;
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
/*      this.getTixianInfo({
        data: {}, success: (res) => {
          if (res.code === 200) {
            console.log('get tixian info', res)
            let tixian_money = (parseFloat(res.data.money) - parseFloat(this.freeze));
            this.tixian_able = tixian_money > 0 ? tixian_money : 0;
            this.zfbMember = res.data.zfbMember
            this.input_zfbMember = res.data.zfbMember ? res.data.zfbMember : ""
            this.zfbName = res.data.zfbName
            this.input_zfbName = res.data.zfbName ? res.data.zfbName : ""
            this.has_zfb = res.data.zfbMember ? false : true
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })*/
    },

    // === 列表===
    handleSearch(page){
      this.page=page
      this.tableData = []
      // this.listTotal = 0
      this.random = Math.random()
      let params = {
        page: this.page,
        page_size: this.page_size,
      }
      if(this.searchParams.type){
        params.type = this.searchParams.type
      }
      if(this.searchParams.use_type){
        params.use_type = this.searchParams.use_type
      }
      if(this.searchParams.order_no){
        params.order_no = this.searchParams.order_no
      }
      if(this.activeTab==='1'){
        this.getRecordData(params)
      }else if(this.activeTab==='2'){
        this.getPowerList(params)
      }else if(this.activeTab==='5'){
        this.getConventionalPowerList(params)
      }
    },
    //获取算力记录流水
    getPowerList(params){
      this.loading=true
      this.getPowerFinanceList({
        data: params, success: (res) => {
          this.loading=false
          if (res.code === 200) {
            this.tableData = res.data.list
            this.listTotal = res.data.total || 0
            if (this.page===1){
              this.useTypeConfig = Object.keys(res.data.use_type_option).map((key) => {
                return {value: key, label: res.data.use_type_option[key]}
              })
              this.typeConfig = Object.keys(res.data.type_option).map((key) => {
                return {value: key, label: res.data.type_option[key]}
              })
            }
          }else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    getConventionalPowerList(params){
      this.loading=true
      this.getConventionalComputingPowerFinanceList({
        data: params, success: (res) => {
          this.loading=false
          if (res.code === 200) {
            this.tableData = res.data.list || []
            this.listTotal = res.data.total || 0
            if (this.page===1){
              this.useTypeConfig = Object.keys(res.data.use_type_option || {}).map((key) => {
                return {value: key, label: res.data.use_type_option[key]}
              })
              this.typeConfig = Object.keys(res.data.type_option || {}).map((key) => {
                return {value: key, label: res.data.type_option[key]}
              })
            }
          } else {
            this.$message({message: res.msg || res.message, type: 'error'})
          }
        }
      })
    },
    //获取钱包记录流水
    getRecordData(params) {
      this.loading=true
      this.getWallteData({
        data: params, success: (res) => {
          this.loading=false
          if (res.code === 200) {
            console.log('get wallet record list', res)
            this.tableData = res.data.list
            this.listTotal = res.data.total
            if (this.page===1){
              this.useTypeConfig = Object.keys(res.data.use_type_option).map((key) => {
                return {label: key, value: res.data.use_type_option[key]}
              })
              this.typeConfig = Object.keys(res.data.type_option).map((key) => {
                return {label: key, value: res.data.type_option[key]}
              })
            }
          } else {
            this.$message({message: res.msg || res.message, type: 'error',});
          }
        }
      })
    },

    handleReset(){
      if(this.activeTab==='3'){
        this.$nextTick(()=>{
          this.$refs.statisicslistRef.init()
        })
      }
      else if(this.activeTab==='4'){
        this.$nextTick(()=>{
          this.$refs.computPowerListRef.init()
        })
      }
      else{
        this.searchParams={ type:'', use_type:'', order_no:'' }
        this.handleSearch(1)
      }
    },
    refreshComputPower(){
      this.getWalletInfo()
      if(this.activeTab==='4'){
        this.$nextTick(()=>{
          this.$refs.computPowerListRef.init()
        })
      }
    },

    openWalletRecharge() {
      this.is_chongzhi = true
      this.rechargeMode = 'web'
      this.walletRechargeAmount = ''
      this.walletRechargeOrder = null
      this.paymentNum = ''
      this.stopWalletRechargeStatusPolling()
    },
    startWalletRecharge() {
      if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(this.walletRechargeAmount) || Number(this.walletRechargeAmount) < 1 || Number(this.walletRechargeAmount) > 50000) {
        this.$message({message: '请输入 1.00 至 50000.00 的充值金额', type: 'error'})
        return
      }
      if (this.walletRechargeLoading) return

      const payWindow = window.open('', '_blank')
      if (!payWindow) {
        this.$message({message: '支付宝页面打开失败，请允许浏览器弹窗后重试', type: 'error'})
        return
      }

      payWindow.name = `alipay_wallet_${Date.now()}`
      this.walletRechargeWindow = payWindow
      this.walletRechargeLoading = true
      this.createWalletRechargeOrder({
        data: {amount: this.walletRechargeAmount},
        success: (res) => {
          this.walletRechargeLoading = false
          if (res.code !== 200 || !res.data || !res.data.pay_form) {
            payWindow.close()
            this.$message({message: res.msg || res.message || '支付订单创建失败', type: 'error'})
            return
          }

          if (!this.submitAlipayForm(res.data.pay_form, payWindow.name)) {
            payWindow.close()
            this.$message({message: '支付页面打开失败，请重试', type: 'error'})
            return
          }

          this.walletRechargeOrder = res.data
          this.$message({message: '已打开支付宝支付页面', type: 'success'})
          this.startWalletRechargeStatusPolling()
        },
        error: () => {
          this.walletRechargeLoading = false
          payWindow.close()
          this.$message({message: '支付订单创建失败，请稍后重试', type: 'error'})
        }
      })
    },
    submitAlipayForm(payForm, target) {
      const wrapper = document.createElement('div')
      wrapper.innerHTML = payForm
      const form = wrapper.querySelector('form')
      if (!form) return false

      form.target = target || '_blank'
      form.style.display = 'none'
      document.body.appendChild(form)
      form.submit()
      window.setTimeout(() => form.remove(), 0)
      return true
    },
    startWalletRechargeStatusPolling() {
      this.stopWalletRechargeStatusPolling()
      this.checkWalletRechargeStatus()
      this.walletRechargeStatusTimer = window.setInterval(() => this.checkWalletRechargeStatus(), 5000)
    },
    stopWalletRechargeStatusPolling() {
      if (this.walletRechargeStatusTimer) {
        window.clearInterval(this.walletRechargeStatusTimer)
        this.walletRechargeStatusTimer = null
      }
    },
    checkWalletRechargeStatus() {
      if (!this.walletRechargeOrder || this.walletRechargeOrder.status === 'paid') return

      this.getWalletRechargeOrder({
        data: {out_trade_no: this.walletRechargeOrder.out_trade_no},
        success: (res) => {
          if (res.code !== 200 || !res.data) return
          this.walletRechargeOrder = {...this.walletRechargeOrder, ...res.data}

          if (res.data.status === 'paid') {
            this.stopWalletRechargeStatusPolling()
            this.$message({message: '充值到账成功', type: 'success'})
            this.is_chongzhi = false
            this.refreshCharge()
          } else if (res.data.status === 'closed') {
            this.stopWalletRechargeStatusPolling()
            this.$message({message: '该充值订单已关闭', type: 'error'})
          } else if (res.data.expired) {
            this.stopWalletRechargeStatusPolling()
            this.$message({message: '该充值订单已过期', type: 'error'})
          }
        }
      })
    },

    bindRecharge() {//充值查询
      if (!this.paymentNum) {
        this.$message({message: '请输入支付订单编号', type: 'error',});
        return false
      }
      if (!this.is_payment) {
        this.is_payment = true
        this.getCheckRecharge({
          data: {
            out_trade_no: this.paymentNum
          }, success: (res) => {
            if (res.code === 200) {
              this.$message({message: res.msg || res.message, type: 'success',});
              setTimeout(() => {
                this.is_payment = false
                this.paymentNum = ""
                this.is_chongzhi = false
                // this.getWalletInfo()
                // this.getRecordData()
                this.refreshCharge()
              }, 500)
            } else {
              this.is_payment = false
              this.$message({message: res.msg || res.message, type: 'error',});
            }
          }
        })
      }
    },
    bindTixian() {//提现
      if (!this.input_tixian) {
        this.$message({message: '请输入提现金额', type: 'error',});
        return false
      }
      if (!this.input_zfbName) {
        this.$message({message: '请输入支付宝名称', type: 'error',});
        return false
      }
      if (!this.input_zfbMember) {
        this.$message({message: '请输入支付宝账号', type: 'error',});
        return false
      }
      if (this.has_zfb && !this.phoneCode) {
        this.$message({message: '请输入短信验证码', type: 'error',});
        return false
      }
      if (!this.is_doTixian) {
        this.is_doTixian = true
        this.doTixian({
          data: {
            money: this.input_tixian,
            zfbName: this.input_zfbName,
            zfbMember: this.input_zfbMember,
            mobile: this.phone,
            code: this.phoneCode,
            type: this.has_zfb ? '1' : '2'
          }, success: (res) => {
            if (res.code === 200) {
              console.log('do tixian', res)
              this.$message({message: res.msg, type: 'success',});
              setTimeout(() => {
                this.is_tixian = false
                this.phoneCode = ""
                this.is_doTixian = false
                // this.getWalletInfo()
                this.refreshCharge()

              }, 500)
            } else {
              this.$message({message: res.msg, type: 'error',});
              this.is_doTixian = false
            }
          }
        })
      }
    },
    checkInput() {//监听输入的支付宝账户是否与上一次提现的账户一致
      if (this.input_zfbName == this.zfbName && this.input_zfbMember == this.zfbMember && this.zfbName != '' && this.zfbMember != '') {
        this.has_zfb = false
      } else {
        this.has_zfb = true
      }
    },
    getPhoneCode(ev) {//获取短信验证码
      let phone = this.phone
      if (!this.is_get_phone_code) {
        this.is_get_phone_code = true
        this.getCodeData({
          data: {
            mobile: phone,
            event: ev,
          }, success: (res) => {
            if (res.code === 200) {
              console.log('get phone code', res)
              this.$message({message: '发送成功~', type: 'success',});
              let timer = setInterval(() => {
                this.phone_second -= 1
                if (this.phone_second == 0) {
                  clearInterval(timer)
                  this.phone_second = 60
                  this.is_get_phone_code = false
                }
              }, 1000)
            } else {
              this.$message({message: res.msg, type: 'error',});
              this.is_get_phone_code = false
            }
          }
        })
      }
    },

    timeCheck() {//日期查询
      this.page = 1
      // this.startTime = this.rangeTime ? this.DateToStr(this.rangeTime[0]) : ''
      // this.endTime = this.rangeTime ? this.DateToStr(this.rangeTime[1]) : ''
      this.getRecordData()
    },
    onExport() {
      this.exLoading = true
      this.opExportBasinessJineFlow({
        data: {
          type: this.recordType,
          page: this.page,
          page_size: this.page_size,
          start_time: this.startTime,
          end_time: this.endTime,
          order_no: this.formInline.order_no,
          is_export: 1
        }, success: (res) => {
          if (res.code === 200) {
            let a = document.createElement('a');
            a.setAttribute('href', res.data)
            a.click()
            this.exLoading = false
          } else {
            this.exLoading = false
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    DateToStr(date) {
      let year = date.getFullYear();//年
      let month = date.getMonth();//月
      let day = date.getDate();//日
      let hours = date.getHours();//时
      let min = date.getMinutes();//分
      let second = date.getSeconds();//秒
      return year + "-" +
          ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" +
          (day > 9 ? day : ("0" + day)) + " " +
          (hours > 9 ? hours : ("0" + hours)) + ":" +
          (min > 9 ? min : ("0" + min)) + ":" +
          (second > 9 ? second : ("0" + second));
    },
    changeType(val) {
      this.recordType = val
      this.page = 1
      this.getRecordData()
    },
    currentChange(val) {
      this.page = val
      this.handleSearch(this.page)
    },
    sizeChange( val){
      this.page_size = val
      this.page = 1
      this.handleSearch(1)
    }
  },
  beforeDestroy() {
    this.stopWalletRechargeStatusPolling()
  }
}
</script>

<style scoped>

.center {
  display: flex;
  flex: 1;
}


.wallet_main {
  padding: 0 40px 36px;
  background: #fff;
  display: flex;
  gap: 40px;
}

.wallet_main .ye_wrap {
  margin-top: 36px;
}

.wallet_main .ye_wrap .balance {
  margin-top: 30px;
  font-weight: bold;
  font-size: 30px;
}

.wallet_main .ye_wrap .balance > em {
  font-size: 50px;
}

.wallet_main .ye_wrap .btn_wrap {
  display: flex;
  margin-top: 40px;
}

.wallet_main .ye_wrap .btn_wrap .btn {
  height: 40px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  box-sizing: border-box;
  cursor: pointer;
}

.wallet_main .ye_wrap .btn_wrap .btn:nth-child(1) {
  width: 135px;
  background: #f0413e;
  color: #fff;
}

.wallet_main .ye_wrap .btn_wrap .btn:nth-child(2) {
  width: 115px;
  background: #fff;
  color: #f0413e;
  border: 1px solid #f0413e;
}

.wallet_main .dk_wrap {
  margin-left: 180px;
  margin-top: 76px;
}

.wallet_main .dk_wrap > p .icon-suo {
  font-size: 16px;
  color: #333;
  margin-right: 12px;
}

.wallet_main .dk_wrap > p .el-icon-unlock {
  font-size: 16px;
  color: #333;
  margin-right: 12px;
}

.wallet_main .dk_wrap > p > em {
  font-size: 18px;
  font-weight: bold;
  margin-left: 8px;
}

.wallet_main .dk_wrap > p .icon-shuoming {
  font-size: 16px;
  color: #558ed5;
  margin-left: 8px;
  cursor: pointer;
}

.wallet_main .dk_wrap > p:nth-child(2) {
  margin-top: 18px;
}

.record_main {
  margin-top: 16px;
  padding: 20px 40px ;
  background: #fff;
  line-height: 1;
}

.record_main .screen_wrap {
  margin-top: 12px;
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}

.screen_wrap .left_tabs {
  display: flex;
  height: 100%;
  width: 50%;
}

.screen_wrap .left_tabs .tab {
  height: 100%;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
}

.screen_wrap .left_tabs .tab > span {
  font-size: 14px;
  color: #333333;
}

.screen_wrap .left_tabs .tab.active::after {
  content: '';
  width: 100%;
  height: 3px;
  background: var(--red);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
}

.screen_wrap .left_tabs .tab.active > span {
  color: var(--red);
  font-weight: bold;
}

.screen_wrap .left_tabs .tab:last-child > span {
  border-right: none;
}

.screen_wrap .right_time {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.screen_wrap .right_time .txt {
  font-size: 14px;
  color: #666666;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.turn_page {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.tixian_main {
  box-sizing: border-box;
  background: #fff;
}

.tixian_main .icon-guanbi {
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  z-index: 222;
}

.tixian_main .title {
  font-size: 20px;
  line-height: 1;
}

.tixian_main .title .icon-qian {
  margin-right: 8px;
  font-size: 24px;
  color: #f38f00;
}

.tixian_main .title .t {
  font-size: 12px;
  color: #666666;
}

.tixian_main .title .t > em {
  color: var(--red);
}

.tixian_main .tx_count {
  margin: 24px 0 6px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 18px;
  display: flex;
  align-items: center;
}

.tixian_main .tx_count .in {
  font-size: 30px;
  color: #333;
  font-weight: bold;
  flex: 1;
  width: 0;
}

.tixian_main .tx_count .in::placeholder {
  font-size: 16px;
  color: #cccccc;
  line-height: 34px;
}

.tixian_main .tx_count .tx {
  font-size: 12px;
  color: #f0413e;
  margin-left: 18px;
  cursor: pointer;
}

.tixian_main .input_line {
  margin: 10px 0 0;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  padding: 0 10px;
  align-items: center;
}

.tixian_main .input_line .txt {
  width: 74px;
  font-size: 12px;
  color: #999999;
}

.tixian_main .input_line .in {
  flex: 1;
  width: 0;
  font-size: 12px;
  color: #333;
}

.tixian_main .input_line .getcode {
  padding-left: 8px;
  border-left: 1px solid #eee;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  line-height: 1;
}

.tixian_main .el_in2 {
  margin: 14px 0 0;
}

.tixian_main .btn_wrap {
  margin: 36px 0 0;
  display: flex;
  justify-content: space-between;
}

.tixian_main .btn_wrap .btn {
  width: 160px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}

.tixian_main .btn_wrap .btn:nth-child(1) {
  border: 1px solid #dddddd;
  color: #333;
}

.tixian_main .btn_wrap .btn:nth-child(2) {
  background: #f0413e;
  color: #fff;
}

.chongzhi_main {
  box-sizing: border-box;
  background: #fff;
}

.chongzhi_main .icon-guanbi {
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  z-index: 222;
}

.chongzhi_main .title {
  display: flex;
  align-items: center;
  margin: 0 22px;
  font-size: 20px;
  line-height: 1;
}

.chongzhi_main .title .icon {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}

.chongzhi_main .input_line {
  margin: 15px 22px 0;
  display: flex;
  align-items: center;
}

.chongzhi_main .input_line .txt {
  font-size: 12px;
  color: #666666;
  margin-right: 10px;
}

.chongzhi_main .input_line .in {
  width: auto;
}

.chongzhi_main .recharge-tabs {
  margin: 18px 22px 0;
}

.chongzhi_main .recharge-tabs .input_line {
  margin: 15px 0 0;
}

.chongzhi_main .recharge-tabs .btn_wrap {
  margin-top: 30px;
}

.chongzhi_main .recharge-notice {
  margin-top: 15px;
  color: #f0413e;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}

.chongzhi_main .wallet-recharge-status {
  margin-top: 15px;
  color: #409eff;
  font-size: 13px;
  line-height: 1.7;
  word-break: break-all;
}

.chongzhi_main .btn_wrap {
  margin: 45px 0 0;
  display: flex;
  justify-content: space-between;
}

.chongzhi_main .btn_wrap .btn {
  width: 160px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}

.chongzhi_main .btn_wrap .btn:nth-child(1) {
  border: 1px solid #dddddd;
  color: #333;
}

.chongzhi_main .btn_wrap .btn:nth-child(2) {
  background: #f0413e;
  color: #fff;
}

.chongzhi_main .btn_wrap .btn.disabled {
  opacity: .6;
  pointer-events: none;
}

.el-date-editor {
  margin-top: unset !important;
}
</style>
<style scoped>

.tixian_mask .el-dialog__body {
  padding-top: 0;
}

.el_input {
  display: flex;
  margin: 14px 32px 0;
  width: initial;
}

.el_input .el-input__inner {
  height: 38px;
  line-height: 38px;
  padding-left: 58px;
  flex: 1;
  width: 0;
}

.el_input .el-input__inner:focus {
  border-color: var(--red);
}

.el_input.el_in2 .el-input__inner {
  padding-left: 100px;
}

.el_input .el-input__prefix {
  left: 2px;
  top: 1px
}

.el_input .el-input__prefix .icons {
  width: 38px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 1px;
  left: 2px;
  background: #f5f5f5;
  border-right: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
}

.el_input .el-input__prefix .icons .iconfont {
  font-size: 20px;
  color: #cccccc;
}

.el_input .el-input__prefix .txts {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.el_input .el-input__suffix {
  display: flex;
}

.el_input .el-input__suffix .el-input__suffix-inner {
  display: flex;
  align-items: center;
}

.el_input .el-input__suffix .el-input__suffix-inner .getcode {
  font-size: 14px;
  color: #333333;
  padding: 0 12px;
  border-left: 1px solid #ccc;
  line-height: 1;
  cursor: pointer;
}

.screen_wrap .right_time .el-input__inner {
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 8px;
  border-radius: 4px;
  width: auto;
  margin-right: 14px;
}

.screen_wrap .right_time .el-date-editor .el-range__icon {
  color: #666;
  line-height: 36px;
}

.screen_wrap .right_time .el-range-editor .el-range-input {
  width: 120px;
  line-height: 36px;
  color: #333;
}

.screen_wrap .right_time .el-date-editor .el-range-separator {
  color: #666;
  line-height: 36px;
  font-size: 12px;
}

.screen_wrap .right_time .el-date-editor .el-range__close-icon {
  line-height: 36px;
  display: none;
}

.el-button--text {
  padding: 7px 15px !important;
}

.el-button--text:hover {
  border-color: var(--red);
  color: var(--red);
}

.el-table .el-table__cell {
  text-align: center;
  padding: 14px 0;
}

.el-table thead .el-table__cell {
  padding: 3px 0;
  background: #f9f9f9;
  color: #666;
  border-bottom: none !important;
}

.chongzhi_main .input_line .in .el-input__inner {
  width: 250px;
  height: 30px;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 14px;
  color: #333;
}


.el-button--small {
  padding: 7px 15px;
}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus, .el-input__inner:focus, .el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover, .el-date-table td.today span, .el-date-table td.available:hover, .el-time-panel__btn.confirm {
  color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-date-table td.end-date span, .el-date-table td.start-date span {
  background-color: var(--red);
}

</style>
